import React, { createContext, useContext, useMemo, useState } from "react"
import { presets } from "./themePresets"

const ExamContext = createContext(null)

export function ExamProvider({ provider, themeKey, children }) {
  const [theme, setTheme] = useState(themeKey || localStorage.getItem("kuizy_theme") || "dark")
  const t = useMemo(() => presets[theme] || presets.dark, [theme])
  const value = useMemo(() => ({ api: provider, theme, setTheme, t }), [provider, theme, t])
  return <ExamContext.Provider value={value}>{children}</ExamContext.Provider>
}

export function useExamApi() {
  const ctx = useContext(ExamContext)
  if (!ctx) throw new Error("useExamApi must be used within ExamProvider")
  return ctx
}
